module.exports = __webpack_public_path__ + "media/images/forms-icons/monetary-icon-hover-a1a4e54d7e81a54842fa4074c3cf2742.svg";